import PropTypes from "prop-types";
import React from "react";

import {
  makeStyles,
  useTheme,
  InputLabel,
  FormControl,
  Select,
  FormHelperText,
} from "@material-ui/core";

/**
 * Select field with custom styling
 */

const useStyles = makeStyles((theme) => ({
  label: {
    color: theme.palette.text.secondary,
    padding: "0 4px",
    "&$focused": { color: theme.palette.text.primary, background: "transparent" },
  },
  focused: {}, // material ui sucks, so this empty object is 100% necessary
}));

export const FilledSelect = ({
  value,
  label,
  helperText,
  InputLabelProps,
  onChange,
  children,
  FormControlProps,
  SelectProps,
  testIds,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const id = `${label.replace(/ +/g, "-")}-input-${Math.random().toString(36).substring(7)}`;
  const labelId = `${id}-label`;

  return (
    <FormControl variant="filled" {...FormControlProps}>
      {label && (
        <InputLabel
          htmlFor={id}
          {...InputLabelProps}
          classes={{ root: classes.label, focused: classes.focused, blurred: classes.blurred }}
          focused
          data-testid={testIds.label}
          style={
            FormControlProps.variant === "outlined"
              ? {
                  background: theme.palette.background.paper,
                  "& label.MuiFocused": { background: "transparent" },
                }
              : {}
          }
        >
          {label}
        </InputLabel>
      )}
      <Select
        value={value}
        onChange={onChange}
        style={{
          background: SelectProps.style || theme.palette.background.default,
        }}
        id={id}
        labelId={labelId}
        data-testid={testIds.select}
        {...SelectProps}
      >
        {children}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

FilledSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  label: PropTypes.string,
  helperText: PropTypes.string,
  InputLabelProps: PropTypes.object,
  onChange: PropTypes.func,
  children: PropTypes.node,
  FormControlProps: PropTypes.object,
  SelectProps: PropTypes.object,
  testIds: PropTypes.object,
};

FilledSelect.defaultProps = {
  value: "",
  label: "",
  helperText: null,
  InputLabelProps: {},
  onChange: () => {},
  FormControlProps: {},
  SelectProps: {},
  children: [],
  testIds: {},
};

export default FilledSelect;
